import type { SlateBlock } from '@atlas/renderer';
import type React from 'react';
import { Element, Path, Transforms, Editor } from 'slate';
import getNode from '@atlas/tool/box/slate/getNode';
import isListBlock from '@atlas/tool/box/slate/isListBlock';

export default function handleListIndentationKeyDownEvent(editor: Editor, event: React.KeyboardEvent): boolean {
    if (!editor.selection) return false;

    if (event.key !== 'Tab') return false;
    if (event.altKey || event.metaKey || event.ctrlKey) return false;

    const { anchor, focus } = editor.selection;

    if (anchor.path[0] !== focus.path[0]) return false;

    const block = getNode<SlateBlock>(editor, [focus.path[0]]);
    if (!block || !isListBlock(block)) return false;

    event.preventDefault();

    if (!Path.equals(anchor.path.slice(0, -2), focus.path.slice(0, -2))) {
        // Shift only if selection in the range of the same list
        return false;
    }

    const inverse = event.shiftKey;

    if (inverse) {
        // No Shift+Tab in top level lists
        if (focus.path.length <= 3) return true;

        Transforms.unwrapNodes(editor, {
            match: (node) => Element.isElement(node) && isListBlock(node),
            mode: 'lowest',
            split: true,
        });
        return true;
    }

    Transforms.wrapNodes(editor, { type: block.type, children: [] });

    return true;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('handleListIndentationKeyDownEvent', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
